"use client"

import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface SectionTransitionProps {
  id: string;
  children: ReactNode;
}

// Versão simplificada sem renderização condicional ou efeitos com base em viewport
const SectionTransition = ({ id, children }: SectionTransitionProps) => {
  // Variantes bem simples que não dependam de whileInView
  const variants = {
    visible: { 
      opacity: 1,
      transition: { duration: 0.6 } 
    }
  };

  return (
    // Renderiza um div regular em vez de section com motion para evitar problemas de renderização
    <div id={id} className="section-wrapper">
      {/* Aplica apenas uma transição de fade simples no mount, sem depender de viewport */}
      <motion.div
        initial={{ opacity: 0 }}
        animate="visible"
        variants={variants}
        style={{ width: '100%' }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default SectionTransition;